import React, {Fragment} from 'react'

import withApiService from '../hoc/with-api-service'
import withData from '../hoc/with-data'

import ProductList from '../product-list'
import SortBy from '../sort-by'
import declOfNum from '../../utils/declOfNum'

const FavoriteContent = ({response, favoritesCount, currentPage, setCurrentPage, sortBy, setSortBy}) => {
  const {data} = response;

  return (
    <Fragment>
      <section className="product-catalogue__head product-catalogue__head_favorite">
        {favoritesCount ?
          (<div className="product-catalogue__section-title">
            <h2 className="product-catalogue__section-name">В вашем избранном</h2>
            <span className="amount amount_favorite">
              {favoritesCount} {declOfNum(favoritesCount, ['товар', 'товара', 'товаров'])}
            </span>
          </div>) :
          (<div className="product-catalogue__section-title">
            <h2 className="section-name">В вашем избранном пока ничего нет</h2>
          </div>)
        }
        {favoritesCount > 0 &&
        <SortBy sortBy={sortBy}
                setSortBy={setSortBy}/>
        }
      </section>
      <section className="product-catalogue__item-list product-catalogue__item-list_favorite">
        {favoritesCount ?
          <ProductList data={data}
                       page="product-card-desktop"/> :
          null
        }
      </section>
    </Fragment>
  )
};

const mapMethodsToProps = (apiService) => {
  return {
    getData: apiService.getProducts
  };
};

export default withApiService(mapMethodsToProps)(withData(FavoriteContent))
